export const availableLanguages = [
  { key: 'fi', name: 'suomeksi', translationKey: 'finnish', availableInAdmin: true },
  { key: 'en', name: 'in English', translationKey: 'english', availableInAdmin: true },
  { key: 'lv', name: 'latviešu valodā', translationKey: 'latvian', availableInAdmin: false },
  { key: 'sv', name: 'på svenska', translationKey: 'swedish', availableInAdmin: false },
  { key: 'de', name: 'auf Deutsch', translationKey: 'german', availableInAdmin: false },
  { key: 'et', name: 'eesti keeles', translationKey: 'estonian', availableInAdmin: false },
  { key: 'ru', name: 'на русском', translationKey: 'russian', availableInAdmin: false },
  { key: 'lt', name: 'lietuvių kalba', translationKey: 'lithuanian', availableInAdmin: false }
]

export const availableLanguagesWopi360 = [
  { key: 'fi', name: 'suomeksi', translationKey: 'finnish', availableInAdmin: true }
]



// WEBPACK FOOTER //
// ./src/assets/translations/availableLanguages.js